import { alpha3ToAlpha2 } from 'i18n-iso-countries';
import * as React from 'react';
import styled from 'styled-components';

import { CountryCode } from '../../api-types/common';
import { fromS3 } from '../../utils/fromS3';

const Image = styled.img`
  width: 20px;
  height: 15px;
`;

type Props = {
  countryCode: CountryCode;
  className?: string;
};

export const Flag = ({ countryCode, className }: Props): React.ReactElement => {
  const alpha2 = countryCode === 'XKX' ? 'xk' : alpha3ToAlpha2(countryCode); // XKX is not in ISO
  const src = fromS3(`icons/flags/${alpha2?.toLowerCase()}.svg`);

  return <Image src={src} className={className} aria-hidden />;
};
